module.exports = __webpack_public_path__ + "img/download-ivy.9455b98f.png";